import { render, staticRenderFns } from "./EmployeeCoursePurchase.vue?vue&type=template&id=46d6f120&scoped=true"
import script from "./EmployeeCoursePurchase.vue?vue&type=script&lang=js"
export * from "./EmployeeCoursePurchase.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCoursePurchase.vue?vue&type=style&index=0&id=46d6f120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6f120",
  null
  
)

export default component.exports